import Vue from "vue";
import Vuetify from "vuetify";
import VueI18n from 'vue-i18n'
import colors from "vuetify/lib/util/colors";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css'
import "vuetify/dist/vuetify";


Vue.use(Vuetify);
Vue.use(VueI18n)

// Translation provided by Vuetify (typescript)


// 201907301735: SASS variables:
// https://vuetifyjs.com/en/customization/sass-variables

// export default new Vuetify({
// 	theme: {
// 		primary: "#1976D2",
// 		secondary: "#424242",
// 		accent: "#82B1FF",
// 		error: "#FF5252",
// 		info: "#2196F3",
// 		success: "#4CAF50",
// 		warning: "#FFC107"
// 	}
// });


const messages = {
	en: {
		$vuetify: {
			dataIterator: {
				rowsPerPageText: 'Element by page:',
				pageText: '{0}-{1} av {2}',
			},
			dataFooter: {
				itemsPerPageText: "Items by page",
				pageText: '{0}-{1} of {2}',
			},
			dataTable: {
				itemsPerPageText: "Element by page",
				sortBy: "Ordenar por"
			},
			TIMEPICKER: {
				PM: "PM",
				AM: "AM"
			}
		},
	},
	es: {
		$vuetify: {
			noDataText: "No hay datos para mostrar" ,
			dataIterator: {
				rowsPerPageText: 'Elementos por página:',
				pageText: '{0}-{1} av {2}',
			},
			dataFooter: {
				itemsPerPageText: "Items por pagina",
				pageText: '{0}-{1} de {2}',
				itemsPerPageAll: "Todos",
				prevPage: "Anterior",
				nextPage: "Siguiente",
			},
			dataTable: {
				itemsPerPageText: "Elementos por página",
				sortBy: "Ordenar por",
				ariaLabel: {
					sortNone: "No ordernar",
					activateAscending: "Activar ascendente"
				}
			},
timePicker: {
	pm: "PM",
				am: "AM"
			}
		},
	},
}

// Create VueI18n instance with options
const i18n = new VueI18n({
	locale: 'es', // set locale
	messages, // set locale messages
})


export default new Vuetify({
	icons: {
		iconfont: 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
	},
	theme: {
		siipo: true,
		themes: {
			siipo: {
				primary: "#1976D2",
				secondary: "#424242",
				accent: "#1976D2",
				error: "#FF5252",
				info: "#2196F3",
				success: "#4CAF50",
				warning: "#FFC107"
			},
			light: {
				primary: colors.blue.darken3,
				secondary: colors.grey,
				accent: colors.shades.black,
				error: colors.red.accent3
			},
			dark: {
				primary: colors.blue.lighten3
			}
		}
	},
	lang: {
		t: (key, ...params) => i18n.t(key, params),
	},
});